import { ActionEnum, ExamDatesForLocationItem } from './types';

export function compareDateOnly(date1: Date, date2: Date): boolean {
  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  );
}

export function compareMonthAndYearOnly(date1: Date, date2: Date): boolean {
  return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth();
}

export function getFirstDayOfCurrentMonth(): Date {
  const today = new Date();
  return new Date(today.getFullYear(), today.getMonth(), 1);
}

export function getNewState(previous: ExamDatesForLocationItem): ExamDatesForLocationItem {
  const active = !previous.active;
  const state =
    previous.action !== ActionEnum.None
      ? ActionEnum.None
      : previous.active
        ? ActionEnum.Deleted
        : ActionEnum.Added;

  return { ...previous, active: active, action: state };
}
